
export const AllProducts =[
    {
        id:'1',
        name: "Bath & Shower OE Shower Gel Bath & Shower",
        photo: "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/67/881947/1.jpg?5184",
        price: 5000,
        subcategory: "Lotion-Gel",
        category: "cosmetics"
    },
    {
        id:'2',
        name: "Iman Cosmetics Extra Shower Gel-2000ml",
        photo: "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/29/640876/1.jpg?9608",
        price: 3980,
        subcategory: "Lotion-Gel",
        category: "cosmetics"
    },
    {
        id:'3',
        name: "Fair & White So White Moisturizing Lotion + Exfoliating Shower Gel",
        photo: "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/40/421127/1.jpg?6931",
        price: 13500,
        subcategory: "Lotion-Gel",
        category: "cosmetics"
    },
    {
        id:'4',
        name: "Fair & White Original Glutathione Exfoliating Shower Gel",
        photo: "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/39/838667/1.jpg?2811",
        price: 7500,
        subcategory: "Lotion-Gel",
        category: "cosmetics"
    },
    {
        id:'5',
        name: "Olay Quench Shimmer Body Lotion , 600ml-With Luminous Minerals",
        photo: "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/43/683177/1.jpg?1369",
        price: 6500,
        subcategory: "Lotion-Gel",
        category: "cosmetics"
    },
    {
        id:'6',
        name: "Longrich NATURAL SNAKE OIL",
        photo: "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/76/773217/1.jpg?0269",
        price: 4500,
        subcategory: "Lotion-Gel",
        category: "cosmetics"
    },
    {
        id:'7',
        name: "Pure Egyptian Magic Whitens Lotion+Serum+Soap",
        photo: "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/40/240607/1.jpg?5606",
        price: 9800,
        subcategory: "Lotion-Gel",
        category: "cosmetics"
    },
    {
        id:'8',
        name: "Gluta White Glutathione & Collagen Lightening 3 Set.",
        photo: "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/40/027217/1.jpg?9663",
        price: 4800,
        subcategory: "Lotion-Gel",
        category: "cosmetics"
    },
    {
        id:'9',
        name: "Dish Washing Liquid",
        photo: "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/12/126146/1.jpg?3160",
        price: 3600,
        subcategory: "Cleaning-Liquids",
        category: "cosmetics"
    },
    {
        id:'10',
        name: "Tide HE Ultra Concentrated Liquid Detergent -5.91L (200 Oz)",
        photo: "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/74/637966/1.jpg?3512",
        price: 23400,
        subcategory: "Cleaning-Liquids",
        category: "cosmetics"
    },
    {
        id:'11',
        name: "Sunlight Multi-Purpose Washing Liquid Lemon 4L",
        photo: "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/43/375165/1.jpg?3652",
        price: 2100,
        subcategory: "Cleaning-Liquids",
        category: "cosmetics"
    },
    {
        id:'12',
        name: "Lavara Moisturising Anti-bacterial Hand Wash For Clean Hands 500ml X 3pieces Mixed Fragrance",
        photo: "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/26/250466/1.jpg?4601",
        price: 3200,
        subcategory: "Cleaning-Liquids",
        category: "cosmetics"
    },
    {
        id:'13',
        name: "Anti Gray Hair Cream",
        photo: "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/03/222667/1.jpg?0449",
        price: 1900,
        subcategory: "Hair-Conditionals",
        category: "cosmetics"
    },
    {
        id:'14',
        name: "Shea Moisture Jamaican Black Castor Oil Strengthen & Restore Shampoo",
        photo: "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/17/285531/1.jpg?3375",
        price: 5500,
        subcategory: "Hair-Conditionals",
        category: "cosmetics"
    },
    {
        id:'15',
        name: "Shea Moisture #Coconut & Hibiscus Curl & Shine Shampoo & Conditioner 2in1.",
        photo: "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/20/518466/1.jpg?9183",
        price: 11500,
        subcategory: "Hair-Conditionals",
        category: "cosmetics"
    },
    {
        id:'16',
        name: "Dexe Black Hair Shampoo/DYE Economic Set. Hair Dye - 200ml",
        photo: "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/86/306985/1.jpg?7307",
        price: 2900,
        subcategory: "Hair-Conditionals",
        category: "cosmetics"
    },
    {
        id:'17',
        name: "Mr Muscle Advanced Power Tough Degreaser 750ml X2",
        photo: "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/57/043846/1.jpg?7230",
        price: 7500,
        subcategory: "Cleaning-Liquids",
        category: "cosmetics"
    },
    {
        id:'18',
        name: "3 in 1 Dinner Plate",
        photo: "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/74/616917/1.jpg?9108",
        price: 20000,
        subcategory: "Dinner-Sets",
        category: "kitchen-and-electronics"
    },
    {
        id:'19',
        name: "Microwave Oven With 20Liters + Blender-999 + Toaster",
        photo: "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/56/864824/1.jpg?6508",
        price: 39400,
        subcategory: "Microwave-and-Blenders",
        category: "kitchen-and-electronics"
    }

]

export default AllProducts;